
export default {
    state: {
        lastOrderNumber: null,
    },
    getters: {
        getLastOrderNumber(state){
            return state.lastOrderNumber
        },
    },
    actions: {

    },
    mutations: {
        setLastOrderNumber(state, val) {
            state.lastOrderNumber = val
        },
    }
}
